import * as React from "react";
import { renderGameState } from "../../EventCard/RenderMethods/renderGameState";
export var renderMiniGameStateWrapper = function (event, componentPrefix, dict, hideGameState) {
    return !hideGameState &&
        React.createElement("div", { className: "rj-ev-list__" + componentPrefix + "__section-item rj-ev-list__" + componentPrefix + "__clock", "data-uat": "div-ev-list-" + componentPrefix + "-clock" }, renderGameState(event.isLive, event.id, event.gamePart, event.gameTime, componentPrefix, dict));
};
//# sourceMappingURL=renderMiniGameStateWrapper.js.map